import { render, staticRenderFns } from "./FolderHeader.vue?vue&type=template&id=32b70bf0&scoped=true"
import script from "./FolderHeader.vue?vue&type=script&lang=js"
export * from "./FolderHeader.vue?vue&type=script&lang=js"
import style0 from "./FolderHeader.vue?vue&type=style&index=0&id=32b70bf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b70bf0",
  null
  
)

export default component.exports